import Swiper, {
  Pagination,
  Thumbs,
  EffectFade,
  Autoplay,
  Navigation,
} from "swiper";

export default function () {
  var swiper = new Swiper(".opinions-swiper", {
    modules: [Pagination, Autoplay],
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    //autoHeight: true, //enable auto height
  });

  var swiper = new Swiper(".partners-swiper", {
    modules: [Autoplay],
    slidesPerView: 2,
    spaceBetween: 20,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
        800: {
          slidesPerView: 5,
        },
    }

  });

  var swiper = new Swiper(".post-news-swiper", {
    modules: [Navigation],
    slidesPerView: 1,
    //loop: true,
    grabCursor: true,
    spaceBetween: 18,
    breakpoints: {
      800: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 3,
      },
    },

    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}
